import React from 'react';
import storageService from '../services/storageService';
// Services
import AuthenticationService from '../services/authenticationService';
import availabilityService from '../services/availabilityStateService';
//import PostMessageService from "../services/postMessageService";
import VIDABOO_CONSTANTS from '../config/consts';
import languageService from '../services/languagesService';
import utilsService from '../services/utilsService';

export const AppContext = React.createContext();

class Context extends React.Component {
  constructor() {
    super();
    let currentUser = {};
    this.state = {
      isAuthorised: currentUser.guest === undefined,
      isImpersonatedModeActive: false,
      isImpersonatedInfoFetched: false,
      authenticationService: new AuthenticationService( //initializing AuthenticationService once here.
        currentUser,
        this.setCurrentUserAfterLogin,
        this.resetContext,
      ),
      sound: {
        websiteBeepSound: JSON.parse(
          storageService.getItem('websiteBeepSound') ?? true,
        ),
        chatBeepSound: JSON.parse(
          storageService.getItem('chatBeepSound') ?? true,
        ),
        callBeepSound: JSON.parse(
          storageService.getItem('callBeepSound') ?? true,
        ),
        forceBeepSound: JSON.parse(
          storageService.getItem('forceBeepSound') ?? true,
        ),
      },
      // beepSound: JSON.parse(storageService.getItem('beepOn') ?? true),
      //postMessageService: PostMessageService,
      currentUser,
      impersonatedCurrentUser: null,
      accountDto: null,
      impersonatedAccountDto: null,
      billingPlanDto: VIDABOO_CONSTANTS.TRIAL_BILLING_PLAN,
      addonPlanDtos: [],
      aiCreditsDto: {
        remainingCredits: 0,
        lastPurchaseDate: '',
        lastPurchaseTotal: 0,
        creditsUsedSinceLastPurchase: 0,
        autoRenew: true,
      },
      billingPlanFetched: false,
      peersStatus: {},
      callState: VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT,
      extendedMeetingRoomDto: null,
      otVideoContainerSize: VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.FULL_SCREEN,
      threedContainerSize: VIDABOO_CONSTANTS.ACTIVE_THREED_SIZE.MEDIUM,
      peerInCall: null,

      widgetLoaded: null,
      autoCallAnswerData: null,
      showChatCue: false,
      chatMessageCueCounter: 0,
      callRecordingInfo: {},
      languageSet: languageService.getLanguageSet('ENGLISH'),
      currentLanguage: 'ENGLISH',
      currentLanguageLocaleKey: 'en',
      siteGuestsWidgetStatusObj: {},
      isAccountManager: null,
      currentUserRoleInAgency:
        VIDABOO_CONSTANTS.RESELLER_AGENCY_USER_ROLES.NONE,
      toastData: [], // shown in bottom left of screen (2 types : 1. vanishes from ui automatically 2. sticky )
      notificationsData: [], // shown in top right of screen
      showNotificationPopUp: false, // shown in middle of screen
      notificationPopUpData: {},
      windowScreenSize:
        window.innerWidth <= VIDABOO_CONSTANTS.RESPONSIVE_BREAKPOINTS.MOBILE
          ? VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE
          : VIDABOO_CONSTANTS.SCREEN_SIZE.DESKTOP,
      showBetaFeaturesPopUp: false,
      showHeaderUpdateBar: false,
      enabledBetaFeatures: [], // VIDABOO_CONSTANTS.BETA_FEATURES ,
    };
  }
  resetContext = () => {
    this.setState({
      billingPlanDto: VIDABOO_CONSTANTS.TRIAL_BILLING_PLAN,
      billingPlanFetched: false,
      accountDto: null,
      impersonatedAccountDto: null,
      addonPlanDtos: [],
      aiCreditsDto: {
        remainingCredits: 0,
        lastPurchaseDate: '',
        lastPurchaseTotal: 0,
        creditsUsedSinceLastPurchase: 0,
        autoRenew: true,
      },
      peersStatus: {},
      callState: VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT,
      extendedMeetingRoomDto: null,
      otVideoContainerSize: VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.FULL_SCREEN,
      threedContainerSize: VIDABOO_CONSTANTS.ACTIVE_THREED_SIZE.MEDIUM,
      peerInCall: null,
      widgetLoaded: null,
      autoCallAnswerData: null,
      showChatCue: false,
      chatMessageCueCounter: 0,
      callRecordingInfo: {},
      languageSet: languageService.getLanguageSet('ENGLISH'),
      currentLanguage: 'ENGLISH',
      currentLanguageLocaleKey: 'en',
      siteGuestsWidgetStatusObj: {}, //{"peerUserId+ "_" + mentorId: obj}
      notificationsData: [],
      isAccountManager: false,
      currentUserRoleInAgency:
        VIDABOO_CONSTANTS.RESELLER_AGENCY_USER_ROLES.NONE,
      isImpersonatedModeActive: false,
      isImpersonatedInfoFetched: false,
      impersonatedCurrentUser: null,
      toastData: [],
      showNotificationPopUp: false,
      notificationPopUpData: {},
    });
  };
  setIsImpersonatedModeActive = (isImpersonatedModeActive) => {
    this.setState({isImpersonatedModeActive});
  };
  setIsImpersonatedInfoFetched = (isImpersonatedInfoFetched) => {
    this.setState({isImpersonatedInfoFetched});
  };
  getCurrentUser = (isImpersonatedModeActive = true) => {
    if (isImpersonatedModeActive && this.state.impersonatedCurrentUser) {
      return this.state.impersonatedCurrentUser;
    }
    return this.state.currentUser;
  };
  setImpersonatedCurrentUser = (impersonatedCurrentUser) => {
    this.setState({impersonatedCurrentUser});
  };
  getAccountDto = (isImpersonatedModeActive = true) => {
    if (isImpersonatedModeActive && this.state.impersonatedAccountDto) {
      return this.state.impersonatedAccountDto;
    }
    return this.state.accountDto;
  };
  setImpersonatedAccountDto = (impersonatedAccountDto) => {
    this.setState({impersonatedAccountDto});
  };
  setSound = (soundObj) => {
    this.setState({sound: soundObj});
  };
  // setBeepSound = (data) => {
  //   this.setState({beepSound: data});
  // };
  setWidgetLoaded = (widgetLoaded) => {
    this.setState({widgetLoaded});
  };
  setPeerStatus = (peerUserId, peerStatus) => {
    const peersStatus = {...this.state.peersStatus};
    peersStatus[peerUserId] = peerStatus;
    this.setState({peersStatus});
  };
  setCurrentUserAfterLogin = (currentUser) => {
    // reseting everything
    this.setState({
      accountDto: null,
      billingPlanDto: VIDABOO_CONSTANTS.TRIAL_BILLING_PLAN,
      addonPlanDtos: [],
    });
    this.setCurrentUser(currentUser);
  };
  setCurrentUser = (currentUser, cb) => {
    // currentUser holds the current user data
    // passing isAuthorised as false will log the user out and navigate the user to login screen
    // cb is optional
    availabilityService.setCurrentUser(currentUser, this.setCurrentUser);
    this.state.authenticationService.setCurrentUser(currentUser);
    if (!currentUser.notificationDtos) currentUser.notificationDtos = {};

    this.setState(
      {
        currentUser,
        isAuthorised: currentUser && currentUser.guest === undefined,
      },
      () => {
        if (cb) {
          cb();
        }
      },
    );
  };

  setCallState = (callState) => {
    this.setState({callState});
  };
  setExtendedMeetingRoomDto = (extendedMeetingRoomDto) => {
    this.setState({extendedMeetingRoomDto});
  };
  setPeerInCall = (peerUserId) => {
    this.setState({peerInCall: peerUserId});
  };
  setOtVideoContainerSize = (otVideoContainerSize) => {
    this.setState({otVideoContainerSize});
  };

  setThreedContainerSize = (threedContainerSize) => {
    this.setState({threedContainerSize});
  };
  setBillingPlanDto = (
    billingPlanDto = VIDABOO_CONSTANTS.TRIAL_BILLING_PLAN,
  ) => {
    this.setState({billingPlanDto, billingPlanFetched: true});
  };
  setAddonPlanDtos = (addonPlanDtos = []) => {
    this.setState({addonPlanDtos});
  };
  setAiCreditsDto = (aiCreditsDto) => {
    this.setState({aiCreditsDto});
  };
  setAccountDto = (accountDto) => {
    this.setState({accountDto});
  };
  setChatMessageCue = (showChatCue) => {
    this.setState({showChatCue});
  };
  setChatMessageCueCounter = (isReset) => {
    if (isReset) {
      this.setState(() => ({chatMessageCueCounter: 0}));
    } else {
      this.setState((prevState) => ({
        chatMessageCueCounter: prevState.chatMessageCueCounter + 1,
      }));
    }
  };

  setAutoCallAnswerData = (autoCallAnswerData) => {
    this.setState({autoCallAnswerData});
  };

  /**
   *
   * @param {*} callRecordingInfo
   */
  setCallRecordingInfo = (callRecordingInfo) => {
    this.setState({callRecordingInfo});
  };

  setLanguageSet = (lang) => {
    const language = utilsService.languagePatch(
      this.state.currentUser.userId,
      lang,
    );
    this.setState({
      currentLanguage: language,
      languageSet: languageService.getLanguageSet(language || 'ENGLISH'),
      currentLanguageLocaleKey: languageService.getLanguageLocalKey(
        language || 'ENGLISH',
      ),
    });
  };

  setSiteGuestsWidgetStatusObj = (peerUserId, widgetStatusObj) => {
    const siteGuestsWidgetStatusObj = {...this.state.siteGuestsWidgetStatusObj};
    siteGuestsWidgetStatusObj[peerUserId] = widgetStatusObj;
    this.setState({siteGuestsWidgetStatusObj});
  };

  setNotificationsData = (notificationsData) => {
    this.setState({notificationsData});
  };

  clearNotificationUsingId = (notificationId) => {
    let notificationsData = [...this.state.notificationsData];
    notificationsData = notificationsData.filter((notificationData) => {
      return notificationData.notificationId !== notificationId;
    });
    this.setState({notificationsData});
  };

  onClearAllNotifications = () => {
    this.setState({notificationsData: []});
  };

  setShowNotificationPopUp = (showNotificationPopUp) => {
    this.setState({showNotificationPopUp});
  };

  setNotificationPopUpData = (notificationPopUpData) => {
    this.setState({notificationPopUpData});
  };

  closeNotificationPopUp = () => {
    this.setState({
      showNotificationPopUp: false,
      notificationPopUpData: {},
    });
  };

  addToastObj = (toastData) => {
    let updatedToastData = [...this.state.toastData];
    const toastObjIdxInArray = updatedToastData.findIndex(
      (toastObj) => toastObj.toastId === toastData.toastId,
    );
    if (toastObjIdxInArray !== -1) {
      // Update the existing toast
      updatedToastData[toastObjIdxInArray] = toastData;
    } else {
      // Add new toast
      updatedToastData.push(toastData);
    }
    this.setState({toastData: updatedToastData});
  };

  removeToastByToastId = (toastId) => {
    let updatedToastData = [...this.state.toastData];
    const toastObjIdxInArray = updatedToastData.findIndex(
      (toastObj) => toastObj.toastId === toastId,
    );
    if (toastObjIdxInArray !== -1) {
      if (updatedToastData[toastObjIdxInArray].timeoutId) {
        window.clearTimeout(updatedToastData[toastObjIdxInArray].timeoutId);
      }
      updatedToastData.splice(toastObjIdxInArray, 1);
      this.setState({toastData: updatedToastData});
    }
  };

  setIsAccountManager = (isAccountManager) => {
    this.setState({isAccountManager});
  };

  setCurrentUserRoleInAgency = (currentUserRoleInAgency) => {
    this.setState({currentUserRoleInAgency});
  };

  setWindowScreenSize = (windowScreenSize) => {
    this.setState({windowScreenSize});
  };

  setShowBetaFeaturesPopUp = (showBetaFeaturesPopUp) => {
    this.setState({showBetaFeaturesPopUp});
  };

  setShowHeaderUpdateBar = (showHeaderUpdateBar) => {
    this.setState({showHeaderUpdateBar});
  };

  setEnabledBetaFeatures = (enabledBetaFeatures) => {
    this.setState({enabledBetaFeatures});
  };

  render() {
    let {
      isAccountManager,
      isAuthorised,
      enabledBetaFeatures,
      showBetaFeaturesPopUp,
      showHeaderUpdateBar,
      authenticationService,
      postMessageService,
      currentUser,
      peersStatus,
      callState,
      extendedMeetingRoomDto,
      peerInCall,
      otVideoContainerSize,
      threedContainerSize,
      billingPlanDto,
      addonPlanDtos,
      billingPlanFetched,
      aiCreditsDto,
      accountDto,
      autoCallAnswerData,
      showChatCue,
      chatMessageCueCounter,
      callRecordingInfo,
      widgetLoaded,
      sound,
      beepSound,
      languageSet,
      currentLanguage,
      currentLanguageLocaleKey,
      siteGuestsWidgetStatusObj,
      notificationsData,
      toastData,
      showNotificationPopUp,
      notificationPopUpData,
      windowScreenSize,
    } = this.state;

    return (
      <AppContext.Provider
        value={{
          isAccountManager,
          isAuthorised,
          authenticationService,
          postMessageService,
          currentUser,
          getCurrentUser: this.getCurrentUser,
          impersonatedCurrentUser: this.state.impersonatedCurrentUser,
          setImpersonatedCurrentUser: this.setImpersonatedCurrentUser,
          sound: sound,
          beepSound: beepSound,
          setCurrentUser: this.setCurrentUser,
          peersStatus,
          setPeerStatus: this.setPeerStatus,
          callState,
          setCallState: this.setCallState,
          extendedMeetingRoomDto,
          setExtendedMeetingRoomDto: this.setExtendedMeetingRoomDto,
          enabledBetaFeatures,
          setEnabledBetaFeatures: this.setEnabledBetaFeatures,
          showBetaFeaturesPopUp,
          setShowBetaFeaturesPopUp: this.setShowBetaFeaturesPopUp,
          showHeaderUpdateBar,
          setShowHeaderUpdateBar: this.setShowHeaderUpdateBar,
          peerInCall,
          setPeerInCall: this.setPeerInCall,
          otVideoContainerSize,
          threedContainerSize,
          setThreedContainerSize: this.setThreedContainerSize,
          setOtVideoContainerSize: this.setOtVideoContainerSize,
          isImpersonatedModeActive: this.state.isImpersonatedModeActive,
          setIsImpersonatedModeActive: this.setIsImpersonatedModeActive,
          isImpersonatedInfoFetched: this.state.isImpersonatedInfoFetched,
          setIsImpersonatedInfoFetched: this.setIsImpersonatedInfoFetched,
          billingPlanDto,
          setBillingPlanDto: this.setBillingPlanDto,
          billingPlanFetched,
          addonPlanDtos,
          setAddonPlanDtos: this.setAddonPlanDtos,
          setAiCreditsDto: this.setAiCreditsDto,
          aiCreditsDto,
          accountDto,
          getAccountDto: this.getAccountDto,
          impersonatedAccountDto: this.state.impersonatedAccountDto,
          setImpersonatedAccountDto: this.setImpersonatedAccountDto,
          setAccountDto: this.setAccountDto,
          autoCallAnswerData,
          setAutoCallAnswerData: this.setAutoCallAnswerData,
          showChatCue,
          setChatMessageCue: this.setChatMessageCue,
          chatMessageCueCounter,
          setChatMessageCueCounter: this.setChatMessageCueCounter,
          setCallRecordingInfo: this.setCallRecordingInfo,
          callRecordingInfo,
          setWidgetLoaded: this.setWidgetLoaded,
          setSound: this.setSound,
          // setBeepSound: this.setBeepSound,
          widgetLoaded,
          setLanguage: this.setLanguageSet,
          languageSet,
          currentLanguage,
          currentLanguageLocaleKey,
          siteGuestsWidgetStatusObj,
          setSiteGuestsWidgetStatusObj: this.setSiteGuestsWidgetStatusObj,
          notificationsData,
          setNotificationsData: this.setNotificationsData,
          clearNotificationUsingId: this.clearNotificationUsingId,
          onClearAllNotifications: this.onClearAllNotifications,
          setIsAccountManager: this.setIsAccountManager,
          currentUserRoleInAgency: this.state.currentUserRoleInAgency,
          setCurrentUserRoleInAgency: this.setCurrentUserRoleInAgency,
          toastData,
          addToastObj: this.addToastObj,
          removeToastByToastId: this.removeToastByToastId,
          showNotificationPopUp,
          notificationPopUpData,
          setShowNotificationPopUp: this.setShowNotificationPopUp,
          setNotificationPopUpData: this.setNotificationPopUpData,
          closeNotificationPopUp: this.closeNotificationPopUp,
          windowScreenSize,
          setWindowScreenSize: this.setWindowScreenSize,
        }}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default Context;
